import { 
    useTheme,
    Box,
    TextField,
} from '@mui/material';
import { PrimaryButton } from '../../general';

const ConversionDescription = ({ edit, description, setDescription, conversion }) => {
    const theme = useTheme();
    return (
        <Box sx={{flex: 1, mb: 1, mt: 4}}>
            <Box 
                sx={{
                    px: 1,
                    pb: description !== conversion?.description && 2,
                    borderRadius: '25px',
                    border: theme.palette.tinyBorder,
                    backgroundColor: theme.palette.mode === 'light' ? '#f0f0f0' : theme.palette.action.disabledBackground,
                }}
            >
                <TextField
                    multiline
                    fullWidth
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    variant="outlined"
                    placeholder="What's this link about?"
                    minRows={1}
                    maxRows={15}
                    sx={{
                        fontSize: '17px',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '25px',
                            border: 'none',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: theme.palette.text.primary,
                        },
                        // Custom Scrollbar Styling
                        '& textarea': {
                            "&::-webkit-scrollbar": {
                                width: "8px",
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: theme.palette.mode === "light" ? "#ccc" : "#2e2e2e",
                                borderRadius: "4px",
                                cursor: 'grab',
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: theme.palette.mode === "light" ? "#e6e6e6" : "#444",
                                borderRadius: "4px",
                            },
                            '&::-webkit-scrollbar-thumb:active': {
                                cursor: 'grabbing',
                            },
                        },
                    }}
                />
                {
                    description !== conversion?.description &&
                    <Box sx={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                        <PrimaryButton
                            text='Save Changes'
                            onClick={() => edit()}
                            styles={{
                                width: '99%',
                                borderRadius: '25px',
                                backgroundColor: theme.palette.primary.main,
                            }}
                        />
                    </Box>
                }
            </Box>
        </Box>
    );
}

export default ConversionDescription;